import { Outlet } from "react-router-dom";
import Sidebar from "../sidebar/SIdebar";
import Header from "../header/header";
import styles from './main.module.css'
import { useEffect, useState } from "react";
import Logout from "../../page/logout/Logout";
import useAutoLogout from "../../page/logout/Autologout";

const MainLayout = () => {
    const [isOpenSide, setIsOpenSide] = useState(window.innerWidth > 768);
    const [logoutModal, setLogoutModal] = useState(false)
    const [session, setSession] = useState(false)


    useEffect(() => {
        const handleResize = () => {
            setIsOpenSide(window.innerWidth > 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    
    useAutoLogout(setLogoutModal, setSession);

    return (
        <div className={`${styles.Appcontainer} ${!isOpenSide ? styles.appcontainer : ''}`}>
            <header>
                <Header
                    isOpenSet={setIsOpenSide} isOpen={isOpenSide} />
            </header>
            <aside
                className={`${styles.aside} ${isOpenSide ? styles.open : styles.close}`}>
                <Sidebar setOpen={setIsOpenSide} open={isOpenSide} onLogoutClick={() => setLogoutModal(true)} />
            </aside>
            <main
                className={isOpenSide ? styles.mainOpen : styles.mainClosed}
            >
                <Outlet />
            </main>
            {logoutModal &&
                <div className={styles.logcontainer}>
                    <Logout session={session} onClose={() => setLogoutModal(false)} />
                </div>}
        </div>
    )
}
export default MainLayout;